module.exports = __webpack_public_path__ + "img/dsci0087.27c8a89e.jpg";